import Immutable from 'immutable';
import { useSelector } from 'react-redux';
import { toCamel } from './string';
/**
 * Retrieve the metatag for the current entity type.
 *
 * @returns {MetatagEntity} - The metatag object.
 */
var useMetatag = function useMetatag() {
  // eslint-disable-next-line max-len
  var metatag = useSelector(function (state) {
    var entityType = state.getIn(['entity', 'entityType'], '') || '';
    var entityId = state.getIn(['entity', 'entityId'], '') || '';
    return state.getIn([entityType ? toCamel(entityType) : entityType, entityId, 'metatag', 'value'], Immutable.Map());
  });
  return metatag.toJS();
};
export default useMetatag;